<div *ngIf="imageUtility.isImage(document.fileName); then imagePreview else documentPreview"></div>
<ng-template #imagePreview>
    <img 
        [src]="document.fileData" 
        [matTooltip]="document.fileName"
        class="document-preview"
    />
    <div *ngIf="showEditIcon" class="edit-container" (click)="onEditClick(document)">
        <mat-icon class="edit-icon">edit</mat-icon>
    </div>
</ng-template>
<ng-template #documentPreview>
    <div class="d-flex flex-column justify-content-center align-items-center document-preview">
        <mat-icon class="document-preview-icon">insert_drive_file</mat-icon>
        <div 
            class="document-title"
            [matTooltip]="document.fileName"
        >
            {{ padString({ str: document.fileName, maxLength: 20, padEnd: true }) }}
        </div>
    </div>
    <div *ngIf="showEditIcon" class="edit-container" (click)="onEditClick(document)">
        <mat-icon class="edit-icon">edit</mat-icon>
    </div>
</ng-template>